import { useTranslation } from "react-i18next";
import ReceiptRow from "./ReceiptRow";
import styles from "../styles/receipt.module.css";

export default function TableBody({
  receipts,
  onEdit,
  onDelete,
  onEmail,
  selectedIds = new Set(),
  onToggleSelect,
}) {
  const { t } = useTranslation();
  return (
    <div className={`${styles["table-body"]} ${styles["table-responsive"]}`}>
      <table>
        <thead>
          <tr>
            <th style={{ width: 36, paddingRight: 0 }}></th>
            <th>{t("recibos.colRecibo")}</th>
            <th>{t("common.filial")}</th>
            <th className="text-end">{t("common.monto")}</th>
            <th>{t("common.fecha")}</th>
            <th>{t("recibos.colMetodo")}</th>
            <th>{t("recibos.colCuenta")}</th>
            <th className="text-center">{t("common.acciones")}</th>
          </tr>
        </thead>
        <tbody>
          {receipts.map((r) => (
            <ReceiptRow
              key={r.id}
              receipt={r}
              onEdit={onEdit}
              onDelete={onDelete}
              onEmail={onEmail}
              selected={selectedIds.has(r.id)}
              onToggleSelect={onToggleSelect}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
